import dataService from 'services/dataService';
import {
  apiDoctorCompliance,
  COMPLIANCE_CSV_REPORT,
} from 'services/dataService/resources';

const ITEMS_PER_PAGE = 100;

const now = new Date();
const INITIAL_STATE = {
  page: 1,
  itemsPerPage: ITEMS_PER_PAGE,
  totalPages: 0,
  totalCount: 0,
  year: now.getFullYear(),
  month: now.getMonth() + 1,
  data: [],
  filters: {
    patientGuid: null,
    doctorGuid: null,
  },
};

const compliance = {
  state: INITIAL_STATE,
  reducers: {
    setPage: (state, payload) => ({
      ...state,
      page: payload < 1 ? 1 : payload,
    }),
    setTotalCountAndTotalPages: (state, payload) => ({
      ...state,
      totalCount: payload.totalCount,
      totalPages: payload.totalPages,
    }),
    reset: () => ({
      ...INITIAL_STATE,
    }),
    setCompliance: (state, payload) => ({
      ...state,
      data: payload,
    }),
    setFilterDates: (state, payload) => ({
      ...state,
      year: payload.year,
      month: payload.month,
    }),
    setFilters: (state, payload) => ({
      ...state,
      filters: {
        ...state.filters,
        ...payload,
      },
    }),
  },
  effects: (dispatch) => ({
    async getReport(payload, state) {
      const {
        year,
        month,
        filters,
        page,
        itemsPerPage: items,
      } = state.compliance;
      const { data } = await dataService.getList(
        apiDoctorCompliance({
          ...filters,
          page,
          items,
          year,
          month,
          tzOffset: now.getTimezoneOffset(),
          doctorGuid: filters?.doctorGuid?.split(','),
        }),
      );
      if (data) {
        dispatch.compliance.setCompliance(data?.data || []);
        const totalCount = data?.count || 0;
        const totalPages = Math.ceil(totalCount / ITEMS_PER_PAGE);
        dispatch.compliance.setTotalCountAndTotalPages({
          totalCount,
          totalPages,
        });
      }
    },
    async setPageCompliance({ pageOffset }, state) {
      const { page, totalPages } = state.compliance;
      const newPage = page + pageOffset;
      dispatch.compliance.setPage(newPage <= totalPages ? newPage : totalPages);

      return dispatch.compliance.getReport();
    },
    async applyFilters(filters, state) {
      const { filters: currentFilters } = state.compliance;

      Object.keys(filters).forEach((key) => {
        if (filters[key] === undefined) delete filters[key];
        else if (filters[key] === 'all') filters[key] = null;
      });
      dispatch.compliance.setPage(1);
      dispatch.compliance.setFilters({
        ...currentFilters,
        ...filters,
      });
    },
    async applyTimeFilter({ year, month }) {
      dispatch.compliance.setFilterDates({ year, month });
      dispatch.compliance.setPage(1);
    },
    async getComplianceCsvReport(payload, state) {
      const { year, month, filters } = state.compliance;
      const reportFilters = {};
      Object.keys(filters).forEach((key) => {
        const filter = filters[key];
        if (filter) {
          reportFilters[key] = filter;
        }
      });

      if (filters.doctorGuid) {
        reportFilters.doctorGuids = filters.doctorGuid.split(',');
        reportFilters.doctorGuid = undefined;
      }

      const { error, data } = await dataService.createOne(
        COMPLIANCE_CSV_REPORT,
        {
          year,
          month,
          tzOffset: now.getTimezoneOffset(),
          ...reportFilters,
        },
      );
      return { error, data };
    },
  }),
};

export default compliance;
